import axiosInstance from '../api.service.js';
import constants from '../../constants/constants.js';

const ENDPOINTORIGIN = "QuickBooks/";

const getQuickBooksData = async (projectNumber) => await axiosInstance.get(ENDPOINTORIGIN + 'GetQuickBooksData?projectNumber=' + projectNumber, constants.REQUIRE_INTERCEPTORS);

export {
    getQuickBooksData
}